import { Label } from '@rossum/api-client/labels';
import { alpha, Chip, Stack, Tooltip } from '@rossum/ui/material';
import { useRef } from 'react';
import { PartyLabelChip } from './PartyLabelChip';

const CHIP_MAX_WIDTH = 240;

type Props = Pick<Label, 'name' | 'color'> & { disabled?: boolean };

export const LabelChip = ({ name, color, disabled }: Props) => {
  const chipEl = useRef<HTMLDivElement>(null);

  const shouldRenderTooltip = chipEl.current
    ? chipEl.current.clientWidth >= CHIP_MAX_WIDTH
    : false;

  return (
    <Tooltip
      placement="top"
      title={shouldRenderTooltip ? name : ''}
      enterDelay={600}
    >
      <Stack ref={chipEl} sx={{ maxWidth: CHIP_MAX_WIDTH }}>
        {color === 'party' ? (
          <PartyLabelChip name={name} />
        ) : (
          <Chip
            label={name}
            sx={
              color && !disabled
                ? {
                    backgroundColor: alpha(color, 0.35),
                    borderColor: alpha(color, 1),
                  }
                : undefined
            }
          />
        )}
      </Stack>
    </Tooltip>
  );
};
